import Vue from 'vue'
import Accounts from '@/api/accounts'

export default {
  namespaced: true,
  state: {
  },
  getters: {
    walletModalViewed: state => {
      return Vue.localStorage.get('walletModalViewed', false)
    },
    captchaEnabled: state => {
      return process.env.CAPTCHA_DISABLED === 'false'
    }
  },
  mutations: {
    setWalletModalViewed (state, viewed) {
      Vue.localStorage.set('walletModalViewed', true)
    }
  },
  actions: {
    async logout ({ commit }) {
      await Accounts.logout()
      commit('users/setUser', null, { root: true })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js